module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号"
    },
    model: {
      value: (_vm.params.order_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "order_id", $$v)
      },
      expression: "params.order_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "推广员"
    },
    model: {
      value: (_vm.params.promoter_mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "promoter_mobile", $$v)
      },
      expression: "params.promoter_mobile"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "value-format": "timestamp",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search_time),
      callback: function($$v) {
        _vm.search_time = $$v
      },
      expression: "search_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品"
    },
    model: {
      value: (_vm.params.item_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_name", $$v)
      },
      expression: "params.item_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "wait",
      "label": "待统计"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "finish",
      "label": "已统计"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "close",
      "label": "关闭"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 170,
      "element-loading-text": "数据加载中",
      "default-sort": {
        prop: 'bind_date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "promoter_mobile",
      "label": "推广员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buy_mobile",
      "label": "购买用户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.item_name)), (scope.row.item_spec_desc) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v(_vm._s(scope.row.item_spec_desc))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售总额",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.price / 100) + "元【数量" + _vm._s(scope.row.num) + "】\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "plan_date",
      "min-width": "80",
      "label": "账期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'finish') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'close') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("关闭")]) : _vm._e(), _vm._v(" "), (scope.row.status == 'wait') ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("待统计")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [15, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6291e880", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6291e880"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/taskBrokerage.vue
// module id = 2773
// module chunks = 0